import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/shadcn/alert-dialog';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'lucide-react';

type AlertVariant = 'info' | 'success' | 'warning' | 'error';

interface AlertNoticeProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Called when dialog should close */
  onClose: () => void;
  /** Dialog title */
  title: string;
  /** Dialog description/message */
  description: string;
  /** Text for the action button */
  actionText?: string;
  /** Visual variant */
  variant?: AlertVariant;
  /** Additional class for the content */
  className?: string;
}

const variantIcons: Record<AlertVariant, React.ReactNode> = {
  info: <Info className="size-6 text-accent" />,
  success: <CheckCircle className="size-6 text-success" />,
  warning: <AlertTriangle className="size-6 text-warning" />,
  error: <XCircle className="size-6 text-destructive" />,
};

export function AlertNotice({
  open,
  onClose,
  title,
  description,
  actionText = 'OK',
  variant = 'info',
  className,
}: AlertNoticeProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <AlertDialogContent className={className}>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            {variantIcons[variant]}
            <AlertDialogTitle>{title}</AlertDialogTitle>
          </div>
          <AlertDialogDescription className="pt-2">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose}>{actionText}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default AlertNotice;
